import React from 'react';
export function Footer() {
  return <footer className="bg-slate-900 text-slate-400 py-12 border-t border-slate-800" data-id="element-79">
      <div className="container mx-auto px-4 max-w-5xl text-center" data-id="element-80">
        <div className="text-white font-bold text-xl mb-6 flex items-center justify-center gap-2" data-id="element-81">
          🚀 EXPEDICIÓN 5TO GRADO
        </div>

        <p className="text-sm max-w-2xl mx-auto mb-8 leading-relaxed" data-id="element-82">
          Este producto tiene fines educativos y de apoyo al aprendizaje en el
          hogar. No reemplaza la formación académica formal ni el trabajo de
          docentes y profesionales de la educación.
        </p>

        <div className="flex flex-wrap justify-center gap-6 text-sm mb-8" data-id="element-83">
          <a href="#" className="hover:text-white transition-colors" data-id="element-84">
            Términos y Condiciones
          </a>
          <a href="#" className="hover:text-white transition-colors" data-id="element-85">
            Política de Privacidad
          </a>
          <a href="mailto:soportetupuntodigital@gmail.com" className="hover:text-white transition-colors" data-id="element-86">
            Contacto
          </a>
        </div>

        <div className="text-xs text-slate-600" data-id="element-87">
          <p data-id="element-88">© 2026 Expedición 5to Grado — Todos los derechos reservados.</p>
        </div>
      </div>
    </footer>;
}